/**
 * Created by Jie Gao on 2018-06-14.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GGInitialWinCountUp} from "../../winpresentation/initial/GGInitialWinCountUp";
import {TimelineMax, TweenLite, Power0, TweenMax} from "gsap";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {FontStyleConfig} from "../../config/FontStyleConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {cloneScreenBounds, ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {GGHelper} from "../../utils/Helper";
import {CoinsFountain} from "../freespinoutro/CoinsFountain";
import {GGGameConfig} from "../../GGGameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class BankBrokeView extends ScreenView {
    private _container:PIXI.Container;
    private _logoL:PIXI.spine.Spine;
    private _logoR:PIXI.spine.Spine;
    private _logoPortrait:PIXI.spine.Spine;
    private _xBet:PIXI.spine.Spine;
    private _maxCap:PIXI.spine.Spine;
    private _winCountUp:GGInitialWinCountUp;
    private _isPortrait:boolean = false;
    private _hasStarted:boolean = false;
    private _idleTimeline:TimelineMax | null;
    private _coinRain:CoinsFountain;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
        this._winCountUp = new GGInitialWinCountUp(FontStyleConfig.CountUp);
    }

    // #576
    public finishPendingWinCap(): void {
        this._button.visible = true;
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();
        this._coinRain = new CoinsFountain();
        this.reset();
        this._winCountUp.position.set(0, 160);
        this._container = container;
        return container;
    }

    protected onResizeButtons(resizeData:IResizeData):void {}

    protected onButtonClick():void {
        super.onButtonClick();
        GGGameModuleConfig.soundPlayer.playCapWinContinueSound();
        this.reset();
    }

    protected setButtonPosition():void {
        this._button.position.x = 360;
        if(NolimitApplication.isLandscape) {
            this._button.position.y = 615;
        } else {
            const bounds:ScreenBounds = cloneScreenBounds(NolimitApplication.screenBounds);
            this._button.position.y = (bounds.bottom - 610) * 0.5 + 610;
        }
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._isPortrait = resizeData.orientation === Orientation.PORTRAIT;
        this._container.position.set(360, 360);
        if(!this._hasStarted) {
            return;
        }
        this.setPos()
    }

    private setPos():void {
        const isPortrait:boolean = this._isPortrait;
        this._logoR.visible = !isPortrait;
        this._logoL.visible = !isPortrait;
        this._logoPortrait.visible = isPortrait;
        const bounds:ScreenBounds = cloneScreenBounds(NolimitApplication.screenBounds);

        if(isPortrait) {
            const topSpace = (bounds.height - 720) * 0.5;
            this._logoPortrait.scale.set(1);
            this._logoPortrait.position.set(0, bounds.top * 0.5 - 300);
            if(topSpace < 170) {
                this._logoPortrait.scale.set(topSpace / 190);
                this._logoPortrait.position.set(0, -317);
            }
            const btnY:number = (bounds.bottom - 610) * 0.5 + 610
            this._xBet.position.set(0, this._winCountUp.position.y + (btnY -360 - this._winCountUp.position.y)*0.5);
        } else {
            this._xBet.position.set(0, -300);
            this._logoL.scale.set(1);
            this._logoR.scale.set(1);
            const leftSpace = (0 - bounds.left) * 0.5;
            if(leftSpace < 140) {
                this._logoL.scale.set(0.9);
                this._logoR.scale.set(0.9);
            }
            this._logoL.position.set(bounds.left - 360 + 190, -60);
            this._logoR.position.set(bounds.right - 360 - 240, -60);
        }
        this._coinRain.position.set(0, 0 - bounds.height * 0.5 - 30);
    }

    protected startPresentation(data:ParsedGameData, onShowComplete:() => void):void {
        // #576
        if (this._hasStarted && GGGameConfig.instance.FAULTY_WIN_CAP) {
            super.startPresentation(data, onShowComplete);

            SlotGame.api.betHandler.zeroBet();
            return;
        }

        this.alpha = 0;
        this._maxCap = GGHelper.createSpineAnimation("Maxcap_Goblin");
        this._logoL = GGHelper.createSpineAnimation("L_Thekingisdead");
        this._logoR = GGHelper.createSpineAnimation("L_Longlivetheking");
        this._logoPortrait = GGHelper.createSpineAnimation("P_Thekingisdead");
        this._xBet = GGHelper.createSpineAnimation("Maxcap_31969X");
        this._container.addChild(this._maxCap);
        this._container.addChild(this._logoR);
        this._container.addChild(this._logoL);
        this._container.addChild(this._logoPortrait);
        this._container.addChild(this._xBet);
        this._container.addChild(this._coinRain);

        this._container.addChild(this._winCountUp);
        this._button.visible = false;
        this._winCountUp.visible = false;
        const tl:TimelineMax = new TimelineMax({
            paused : true,
            onComplete : () => {
                super.startPresentation(data, onShowComplete);

                // #576
                if (GGGameConfig.instance.FAULTY_WIN_CAP) {
                    SlotGame.api.betHandler.zeroBet();
                } else {
                    this._button.visible = true;
                }
            }
        });
        tl.add([
            () => {
                this._hasStarted = true;
                this.setPos();
                GGGameModuleConfig.soundPlayer.playCapWinStartSound();
                this._maxCap.state.setAnimation(0, "Coming_Up", false);
                this._logoR.state.setAnimation(0, "Coming_Up", false);
                this._logoL.state.setAnimation(0, "Coming_Up", false);
                this._xBet.state.setAnimation(0, "Coming_Up", false);
                this._logoPortrait.state.setAnimation(0, "P_Coming_Up", false);
                this._maxCap.visible = true;
                this._xBet.visible = true;
            },
            TweenLite.fromTo(this, 1, {alpha : 0}, {alpha : 1})
        ]);
        tl.add([
            () => {
                this._coinRain.playMaxCap(5);
                this._winCountUp.visible = true
            },
            this._winCountUp.getCountUpAnimation(0, data.totalWin, 4, false)
        ]);
        tl.add(() => {
            this._maxCap.state.setAnimation(0, "Idle", true);
            this._logoR.state.setAnimation(0, "Idle", true);
            this._logoL.state.setAnimation(0, "Idle", true);
            this._xBet.state.setAnimation(0, "Idle", true);
            this._logoPortrait.state.setAnimation(0, "P_Idle", true);
            this._coinRain.playMaxCap(3);
            this.startIdle()
        }, 7.06);
        tl.add(() => GGGameModuleConfig.soundPlayer.playCapWinLoopSound(), 6);
        tl.play(0);
    }

    private startIdle():void {
        this._idleTimeline = new TimelineMax();

        this._idleTimeline!.add([
            TweenMax.to(this._logoR.scale, 0.6, {x : 1.06, y : 1.06, repeat : -1, yoyo : true, ease : Power0.easeNone}),
            TweenMax.to(this._logoL.scale, 0.6, {
                x : 1.06,
                y : 1.06,
                repeat : -1,
                yoyo : true,
                ease : Power0.easeNone,
                delay : 0.2
            }),
            TweenMax.to(this._logoPortrait.scale, 0.6, {
                x : 1.06,
                y : 1.06,
                repeat : -1,
                yoyo : true,
                ease : Power0.easeNone
            })
        ]);
    }

    private reset():void {
        this._hasStarted = false;
        this._winCountUp.visible = false;
        if(!this._maxCap) {
            return;
        }
        if(this._coinRain) {
            this._coinRain.stop();
        }
        this._logoR.destroy();
        this._logoL.destroy();
        this._logoPortrait.destroy();
        this._maxCap.destroy();
        this._xBet.destroy();
        this._idleTimeline?.kill();
        this._idleTimeline = null;
    }
}